import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useProfile } from '@/hooks/useProfile';

export interface AdminTeam {
  id: string;
  name: string;
  description: string | null;
  icon: string;
  created_at: string;
  updated_at: string;
  member_count: number;
}

export const useAllTeams = () => {
  const { isAdmin } = useProfile();

  return useQuery({
    queryKey: ['admin-teams'],
    enabled: isAdmin,
    queryFn: async (): Promise<AdminTeam[]> => {
      const { data, error } = await supabase
        .from('teams')
        .select('id, name, description, icon, created_at, updated_at, team_members(count)')
        .order('created_at', { ascending: false });

      if (error) throw error;

      return (data ?? []).map((t: any) => ({
        id: t.id,
        name: t.name,
        description: t.description,
        icon: t.icon,
        created_at: t.created_at,
        updated_at: t.updated_at,
        member_count: t.team_members?.[0]?.count ?? 0,
      }));
    },
  });
};
